<script lang="ts">
	import { mount, onMount } from 'svelte';
	import TextTemplate from './TextTemplate.svelte';
	import { preprocessContent } from './utils';

	interface Props {
		/* eslint svelte/no-at-html-tags: "off" */
		content: string;
		linksLocation?: string;
		class?: string;
		variables?: Record<string, string>;
	}

	let { content, linksLocation = '', class: clazz = '', variables }: Props = $props();

	let el: HTMLElement | undefined = $state();

	onMount(() => {
		if (!el) return;
		const links = Array.from(el.querySelectorAll('a'));
		links.forEach((link) => {
			link.setAttribute('data-location', linksLocation);
		});

		const textTemplates = Array.from(el.querySelectorAll('text-template'));
		textTemplates.forEach((textTemplate) => {
			const div = document.createElement('div');
			const uid = textTemplate.getAttribute('data-uid');
			if (uid) {
				mount(TextTemplate, {
					target: div,
					props: { uid }
				});
				textTemplate.replaceWith(div);
			}
		});
	});
</script>

<div bind:this={el} class={`editor-content ${clazz}`}>
	{@html preprocessContent(content, variables)}
</div>
